import React from 'react';
import ReactDOM from 'react-dom';
import 'react-hot-loader';

import { HotmartRum } from '@hot-observability-js/react';
import Settings from 'configs/Settings';
import { App } from 'modules/app';
import { UiService } from 'modules/ui';

import { SENTRY_DSN } from '../config/constants';
import pkjson from '../package.json';

import { UploadInterceptor } from '@hotmart/club-files-ui';

if (!Settings.isLocal) {
  HotmartRum.init({
    dsn: SENTRY_DSN,
    release: `${pkjson.name}@${process.env.DRONE_COMMIT_SHA}`,
    environment: Settings.isProduction() ? 'production' : 'staging'
  });
}

new UploadInterceptor({
  callback: UiService.handleInvalidToken
}).setInterceptors();

const root = document.getElementById('app');

if (module.hot) {
  module.hot.accept();
}

ReactDOM.render(<App />, root);
